"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContrast = getContrast;
exports.getContrastForegroundColor = getContrastForegroundColor;
exports.getLuminance = getLuminance;
exports.setAlpha = void 0;
exports.toLinearRgb = toLinearRgb;

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setAlpha = function setAlpha(color, alpha) {
  return color ? (0, _color.default)(color).alpha(alpha).toString() : color;
};
/**
 * https://www.w3.org/WAI/GL/wiki/Relative_luminance
 * @param {number} rgbColorChannel - R or G or B, number between 0 and 255
 * @returns {number}
 */


exports.setAlpha = setAlpha;

function toLinearRgb(rgbColorChannel) {
  var normalizedRgbColorChannel = rgbColorChannel / 255;
  return normalizedRgbColorChannel <= 0.03928 ? normalizedRgbColorChannel / 12.92 : Math.pow((normalizedRgbColorChannel + 0.055) / 1.055, 2.4);
}
/**
 * Returns the relative luminance of a color
 * https://www.w3.org/WAI/GL/wiki/Relative_luminance
 * @param {number} r - number between 0 and 255
 * @param {number} g - number between 0 and 255
 * @param {number} b - number between 0 and 255
 * @returns {number}
 */


function getLuminance(r, g, b) {
  var linearR = toLinearRgb(r);
  var linearG = toLinearRgb(g);
  var linearB = toLinearRgb(b);
  return 0.2126 * linearR + 0.7152 * linearG + 0.0722 * linearB;
}
/**
 * Returns contrast ration between 2 given colors
 * https://www.w3.org/WAI/GL/wiki/Relative_luminance
 * @param {{r: number, g: number, b: number}} color1
 * @param {{r: number, g: number, b: number}} color2
 * @returns {number}
 */


function getContrast(color1, color2) {
  var luminance1 = getLuminance(color1.r, color1.g, color1.b);
  var luminance2 = getLuminance(color2.r, color2.g, color2.b);
  var light = Math.max(luminance1, luminance2);
  var dark = Math.min(luminance1, luminance2);
  return (light + 0.05) / (dark + 0.05);
}
/**
 * Returns 'white' or 'black', whichever provides greater contrast with the given color.
 * @param {{r: number, g: number, b: number}} color
 * @returns {'white' | 'black'}
 */


function getContrastForegroundColor(color) {
  var contrastWithWhite = getContrast(color, {
    r: 255,
    g: 255,
    b: 255
  });
  var contrastWithBlack = getContrast(color, {
    r: 0,
    g: 0,
    b: 0
  });
  var contrastForegroundColor = contrastWithWhite > contrastWithBlack ? 'white' : 'black';
  return contrastForegroundColor;
}